var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCetus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0028 8.75C14.7881 8.75 9.75 13.7756 9.75 19.9749C9.75 23.2082 11.1204 26.1221 13.3134 28.1704L12.024 33.7387C12.5594 33.8632 13.1173 33.929 13.6906 33.929C16.0442 33.929 18.1381 32.8199 19.4756 31.097C19.9747 31.1649 20.4847 31.1999 21.0028 31.1999C27.0967 31.1999 32.0592 26.3679 32.25 20.3354L21.0028 20.3354V20.3182C18.5892 20.3182 16.6325 18.3664 16.6325 15.9587C16.6325 13.551 18.5892 11.5991 21.0028 11.5991C23.4165 11.5991 25.3732 13.551 25.3732 15.9587C25.3732 16.6829 25.1962 17.3658 24.8829 17.9668C26.8999 17.9668 28.0027 17.2558 28.1916 15.8336C28.7079 17.2443 30.0027 17.9554 32.0761 17.9668C31.1272 12.7257 26.5305 8.75 21.0028 8.75Z",
    fill: "#00D89A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2084_29926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 24,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0028 8.75C14.7881 8.75 9.75 13.7756 9.75 19.9749C9.75 23.2082 11.1204 26.1221 13.3134 28.1704L12.024 33.7387C12.5594 33.8632 13.1173 33.929 13.6906 33.929C16.0442 33.929 18.1381 32.8199 19.4756 31.097C19.9747 31.1649 20.4847 31.1999 21.0028 31.1999C27.0967 31.1999 32.0592 26.3679 32.25 20.3354L21.0028 20.3354V20.3182C18.5892 20.3182 16.6325 18.3664 16.6325 15.9587C16.6325 13.551 18.5892 11.5991 21.0028 11.5991C23.4165 11.5991 25.3732 13.551 25.3732 15.9587C25.3732 16.6829 25.1962 17.3658 24.8829 17.9668C26.8999 17.9668 28.0027 17.2558 28.1916 15.8336C28.7079 17.2443 30.0027 17.9554 32.0761 17.9668C31.1272 12.7257 26.5305 8.75 21.0028 8.75Z",
    fill: "#00FFD6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2084_29926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7875 28.6768C10.4397 28.6768 5.29379 23.5436 5.29379 17.2116C5.29379 10.8795 10.4397 5.74634 16.7875 5.74634C23.1353 5.74634 28.2812 10.8795 28.2812 17.2116C28.2812 23.5436 23.1353 28.6768 16.7875 28.6768Z",
    fill: "#00FFD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCetus);
export default __webpack_public_path__ + "static/media/cetus.db4b43ec854f633c305dc68ae0ca6f4a.svg";
export { ForwardRef as ReactComponent };